import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  background: (p) => p.palette.common.white,
  padding: (p) => p.spacing(3),
  gap: (p) => p.spacing(1),
  borderRadius: (p) => p.spacing(2),
};

export const icon: SxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: 'white',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
  backgroundColor: (p) => p.palette.grey[500],
  borderRadius: '50%',
};

export const videoBox: SxStyle = {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
};

export const chip: SxStyle = {
  mt: 2.5,
  mx: 'auto',
  cursor: 'pointer',
};

export const modalBox: SxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 960,
  backgroundColor: 'background.paper',
  boxShadow: 24,
};

export const modalIframe: SxStyle = {
  display: 'block',
  width: '100%',
  aspectRatio: '16 / 9',
  border: 'none',
  borderRadius: (p) => p.spacing(0.5),
};
